import screens from "../screens";

import nativeRoutes from "./routes.native";

let routes = {
  "#": screens.WebSurvey,
};

if (__DEV__) {
  routes = {
    ...routes,
    ...nativeRoutes,
  };
}

export default routes;
